import React from "react";

export default function MenuItem(props) {
  const { menuItem, lang } = props;

  return (
    <li>
      {menuItem.photo !== "" ? <MenuPhoto menuItem={menuItem} /> : ""}
      <div className="data-wrapper">
        <div className="data-block">
          <div className="title">{menuItem["title_" + lang]}</div>
          <div className="price">{`${menuItem.price}€`}</div>
        </div>
        <div className="data-block">
          <div className="desc">{menuItem["desc_" + lang]}</div>
        </div>
        <div className="data-block">
          <div className="allergens">
            <img
              className="allergen"
              src="/img/allergens/gluten.svg"
              alt="alérgeno gluten"
            />
          </div>
        </div>
      </div>
    </li>
  );
}

const MenuPhoto = (props) => {
  return (
    <img src={`/img/dishes/${props.menuItem.photo}`} alt="imagen del plato x" />
  );
};
